export default __webpack_public_path__ + "static/media/check_item_details.ff810084.svg";